<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new employee</small>
      </legend>
      <div>
        <form @submit.prevent="newEmployee()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Employee names</label>
                <input
                  type="text"
                  class="form-control employee_name"
                  placeholder="employee name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Id number</label>
                <input type="number" class="form-control id_no" placeholder="id no" required />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>gender</label>
                <select name="gender" class="form-control gender" required>
                  <option value>select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="form-group">
                <label>Phone number</label>
                <input type="number" class="form-control phone_no" placeholder="phone no" required />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingEmployee">
            <i class="fa fa-user"></i> create employee
          </button>
          <button type="button" class="btn btn-info btn-flat creatingEmployeeLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
export default {

  methods: {
    ...mapActions(["newEmployee"])
  }
};
</script>
<style scoped>
.creatingEmployeeLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/employees/employee.vue